import { buildKey, useLocalStorage } from "./useLocalStorage";

const SELECTED_GROUP_STORAGE_KEY = "group-selected-tab";

enum GroupsTabItems {
  MY_GROUPS = "MY_GROUPS",
  FIND_GROUPS = "FIND_GROUPS",
}

const useSelectGroupsTab = () => {
  const [selectedTab, setSelectedTab] = useLocalStorage<GroupsTabItems>(
    SELECTED_GROUP_STORAGE_KEY,
    GroupsTabItems.FIND_GROUPS,
  );

  const getInitialGroupsRoute = () => {
    const localStorageKey = buildKey(SELECTED_GROUP_STORAGE_KEY);
    const prevLocation = localStorage.getItem(localStorageKey);

    if (!prevLocation) {
      return "/groups/discover";
    }
    if (prevLocation === GroupsTabItems.MY_GROUPS) {
      return "/groups";
    }

    return "/groups/discover";
  };

  const initialGroupsRoute = getInitialGroupsRoute();

  return {
    selectedTab,
    setSelectedTab,
    initialGroupsRoute,
  };
};

export { useSelectGroupsTab, GroupsTabItems };
